import { Component, EventEmitter, Input, OnInit, Output, NgModule } from '@angular/core';
import { catchError, of } from 'rxjs';
import { PaymentMethodService } from '../../../../services/payment-method.service';

@Component({
  selector: 'app-add-edit-payment-method',
  templateUrl: './add-edit-payment-method.component.html',
  styleUrls: ['./add-edit-payment-method.component.css']
})

export class AddEditPaymentMethodComponent implements OnInit {

  @Input() ban: any;
  @Input() paymentMethodData: any;

  @Output() getPaymentMethods = new EventEmitter<any>();
  @Output() closeModal = new EventEmitter<any>();

  public paymentFormCard: any;
  public paymentFormBank: any;
  public apiError: any = '';
  public encryptedData: any = "";
  public selectedOption: any = 'Bank';
  public isAPIResponsePending: boolean = false;

  constructor(private paymentsService: PaymentMethodService) { }

  ngOnInit() {
    document.body.style.overflow = 'hidden';
    if (this.paymentMethodData.paymentType == 'Card') {
      this.selectedOption = 'Card';
    }
    else {
      this.selectedOption = 'Bank';
    }
  }

  changeAddMethod(option: any) {
    this.selectedOption = option;
  }

  addPaymentMethod(formData: any) {
    this.isAPIResponsePending = true;
    this.paymentsService.addPaymentMethod(formData)
      .pipe(
        catchError((error) => {
          this.isAPIResponsePending = false;
          this.apiError = error;
          return of(null);
        })
      ).subscribe((res: any) => {
        if (res !== null) {
          this.emitToParent();
        }
      });
  }

  updatePaymentMethod(formData: any) {
    this.isAPIResponsePending = true;
    this.paymentsService.updatePaymentMethod(formData)
      .pipe(
        catchError((error) => {
          this.isAPIResponsePending = false;
          this.apiError = error;
          return of(null);
        })
      ).subscribe((res: any) => {
        if (res !== null) {
          this.emitToParent();
        }
      });
  }

  emitToParent() {
    this.isAPIResponsePending = false;
    this.getPaymentMethods.emit('getPaymentMethods');
  }

  closePopup() {
    this.closeModal.emit();
  }

  ngOnDestroy() {
    document.body.style.overflow = 'auto';
  }
}
